import {
  Text,
  Flex,
  Icon,
  Tag,
  Stack,
  Skeleton,
  Tooltip,
  useDisclosure,
  useMediaQuery
} from "@chakra-ui/react";
import { HiMapPin } from "react-icons/hi2";

import { ReactElement } from "react";

import { Image } from "@/storybook-components";

export interface PinDetailsProps {
  pinType?: string;
  pinAddress?: string;
  isLoaded?: boolean;
  pinColor?: string;
  pinImageSrc?: string;
  isAddressVisible?: boolean;
  pinIcon?: ReactElement;
}

const DEFAULT_PIN_CHAR = 32;

export const PinDetails = (props: PinDetailsProps) => {
  const {
    pinType,
    pinAddress,
    isLoaded,
    pinColor,
    pinImageSrc,
    pinIcon,
    isAddressVisible
  } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const pinStructure = () => {
    if (pinImageSrc) {
      return <Image src={pinImageSrc} height={6} width={6} alt={pinType} />;
    } else if (pinIcon) {
      return pinIcon || null;
    } else {
      return (
        <Icon
          justifySelf="flex-start"
          aria-label="See menu"
          minWidth={6}
          as={HiMapPin}
          width={6}
          height={6}
          color={pinColor || "purple.600"}
          data-testid="card-mapPinIcon"
        />
      );
    }
  };

  const pinTypeLength = pinType?.length;
  const tagProps = {
    colorScheme: "purple",
    variant: "solid",
    "data-testid": "card-pinTypeTag",
    bg: pinColor,
    px: 2,
    py: 1,
    mt: "6px",
    display: "inline-flex",
    alignItems: "center",
    style: { ...(pinIcon ? { height: 22, mt: 1 } : {}) }
  };

  const pinTagDetails = () => {
    return (
      <Tooltip
        isOpen={isOpen}
        label={pinType}
        hasArrow
        placement="top"
        openDelay={300}
        closeDelay={3000}
        closeOnClick={false}
        shouldWrapChildren={false}
      >
        <Tag
          {...tagProps}
          onClick={isMobile ? () => onOpen() : null}
          onTouchStart={isMobile ? () => onOpen() : null}
          onMouseEnter={!isMobile ? () => onOpen() : null}
          onMouseLeave={onClose}
        >
          <Text isTruncated maxW="100%">
            {pinType}
          </Text>
        </Tag>
      </Tooltip>
    );
  };

  const displayPintype = () => {
    return pinTypeLength > DEFAULT_PIN_CHAR ? (
      pinTagDetails()
    ) : (
      <Tag {...tagProps}>
        <Text isTruncated maxW="100%">
          {pinType}
        </Text>
      </Tag>
    );
  };
  return (
    <Skeleton isLoaded={isLoaded}>
      <Stack width="full">
        <Flex gap={1}>
          {pinStructure()}
          {pinType && displayPintype()}
        </Flex>
        {isAddressVisible && (
          <Text
            fontSize="xs"
            fontWeight={500}
            data-test-id="card-pinAddressText"
          >
            {pinAddress}
          </Text>
        )}
      </Stack>
    </Skeleton>
  );
};
